module.exports = __webpack_public_path__ + "img/EtikettGap.18f75941.png";